<ng-template #profileModal let-modal>
  <form [formGroup]="formGroup">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Complete Profile</h4>
      <button type="button" class="btn-close" aria-label="Close" title="Close Modal"
        (click)="resetForm();modal.dismiss('Cross click');"></button>
    </div>
    <div class="modal-body">
      <div class="profile-modal-tab-icon-wrap">
        <div class="icon-block">
          <img [src]="user.profilePicture ? user.profilePicture : './assets/images/profile-tab-view.svg'" alt="Icon"
            height="183px" width="183px">
          <app-input [inputType]="'file'" [fieldValue]="" [fieldText]="" [acceptFormat]="'image/*'"
            [fControl]="formGroup.controls['ProfilePicture']" [inputClass]="'form-control'" [inputPlaceholder]="''"
            [inputLabel]="''" [labelClass]="'form-label'" [isRequired]="false"
            (change)="onFileSelected($event)"></app-input>
        </div>
      </div>
      <div class="profile-tab-slider-outer">
        <div class="dots">
          <button class="dot" [class.active]="selectedTab === 1" (click)="nextTab()"></button>
          <button class="dot" [class.active]="selectedTab === 2" (click)="nextTab()"></button>
        </div>
        <div class="navigation-wrapper">
          <div>
            <div class="slider-block-child number-slide1" *ngIf="selectedTab === 1">
              <h5 class="profile-user-name">
                {{ user.firstName }} {{ user.lastName }}
              </h5>
              <div class="row modal-form-row" [formGroup]="formGroup">
                <div class="col-12">
                  <div>
                    <app-input [inputType]="'text'" [fieldValue]="user.address" [fieldText]="'address'"
                      [fControl]="formGroup.controls['Address']" [inputClass]="'form-control'"
                      [inputPlaceholder]="'Enter Address'" [inputLabel]="'Address'" [labelClass]="'form-label'"
                      [isRequired]="false" (keydown.enter)="$event.preventDefault()" appNoSpecialCharacter [maxLengthValidationMsg]="'Address must be at most 255 characters long.'
                      "></app-input>
                  </div>
                </div>
                <div class="col-6">
                  <div>
                    <app-input [inputType]="'text'" [fieldValue]="user.city" [fieldText]="'city'"
                      [fControl]="formGroup.controls['City']" [inputClass]="'form-control'" [inputPlaceholder]="'Enter City'"
                      [inputLabel]="'City'" [labelClass]="'form-label'" [isRequired]="false"
                      [maxLengthValidationMsg]="'City must be at most 30 characters long.'" (keydown.enter)="$event.preventDefault()" appAlphabetOnly></app-input>
                  </div>
                </div>
                <div class="col-6">
                  <div>
                    <app-input [inputType]="'text'" [fieldValue]="user.zip" [fieldText]="'zip'"
                      [fControl]="formGroup.controls['Zip']" [inputClass]="'form-control'" [inputPlaceholder]="'Enter Zip'"
                      [inputLabel]="'Zip'" [labelClass]="'form-label'" [isRequired]="false" [maxLengthValidationMsg]="
                      'Zip must be at most 15 characters long.'
                    " [minLengthValidationMsg]="
                    'Zip must be at least 5 characters long.'
                  " [customErrorValidationMsg]="
                  'Zip can contains only alphabets and digits'
                "
                (keydown.enter)="$event.preventDefault()"
                ></app-input>
                  </div>
                </div>
                <div class="col-12">
                  <div>
                    <app-input [inputType]="'text'" [fieldValue]="user.mobileNumber" [fieldText]="'phone'"
                      [fControl]="formGroup.controls['Phone']" [inputClass]="'form-control'"
                      [inputPlaceholder]="'Enter Phone'" [inputLabel]="'Phone'" [labelClass]="'form-label'"
                      [isRequired]="false" [minLengthValidationMsg]="
                      'Phone Number must be at least 7 digits long.'
                    " [maxLengthValidationMsg]="
                      'Phone Number must be at most 15 digits long.'
                    " [customErrorValidationMsg]="'Phone Number contains only digits.'" appNumbersOnly
                    (keydown.enter)="$event.preventDefault()"></app-input>
                  </div>
                </div>
              </div>
              <div class="btn-grps mt-4">
                <app-button [btnText]="'Select Location'" [btnTitle]="'Select Location'"
                  [btnCss]="'btn btn-outline-primary w-100 btn-lg btn-md'" (onBtnClick)="
                    openModal(searchLocationComponent.searchLocationTemplate, 'search-location-modal');
                    modal.dismiss('Cross click')
                  ">
                  <div class="svg-wrap">
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6C12 8.484 10.1067 11.0867 6.4 13.8667C6.2846 13.9532 6.14425 14 6 14C5.85575 14 5.7154 13.9532 5.6 13.8667C1.89333 11.0867 0 8.484 0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0ZM6 4C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6C4 6.53043 4.21071 7.03914 4.58579 7.41421C4.96086 7.78929 5.46957 8 6 8C6.53043 8 7.03914 7.78929 7.41421 7.41421C7.78929 7.03914 8 6.53043 8 6C8 5.46957 7.78929 4.96086 7.41421 4.58579C7.03914 4.21071 6.53043 4 6 4Z"
                        fill="currentcolor" />
                    </svg>
                  </div>
                </app-button>
                <app-button [btnText]="'Next'" [btnTitle]="'Next'" [btnCss]="'btn btn-primary w-100 btn-lg'"
                  (onBtnClick)="nextTab()"></app-button>
              </div>
            </div>
            <div class="slider-block-child number-slide2" *ngIf="selectedTab === 2">
              <h5 class="profile-subtitle">Personal Details</h5>
              <h6 class="under-text">My social media</h6>
              <div class="row modal-form-row">
                <div class="col-12">
                  <div>
                    <app-input [inputType]="'text'" [fieldValue]="user.instagramId" [fieldText]="'instagram'"
                      [fControl]="formGroup.controls['Instagram']" [inputClass]="'form-control'"
                      [inputPlaceholder]="'Enter Instagram ID'" [inputLabel]="'Instagram'" [labelClass]="'form-label'"
                      [isRequired]="false" [customErrorValidationMsg]="'Invalid Instagram ID'"
                      (keydown.enter)="$event.preventDefault()" [maxLengthValidationMsg]="'Instagram ID must be at most 30 characters long.'
                    "></app-input>
                  </div>
                </div>
                <div class="col-12">
                  <div>
                    <app-input [inputType]="'text'" [fieldValue]="user.tikTokId" [fieldText]="'tiktok'"
                      [fControl]="formGroup.controls['Tiktok']" [inputClass]="'form-control'"
                      [inputPlaceholder]="'Enter Tiktok ID'" [inputLabel]="'Tiktok'" [labelClass]="'form-label'"
                      [isRequired]="false" [customErrorValidationMsg]="'Invalid TikTok ID'"
                      (keydown.enter)="$event.preventDefault()" [maxLengthValidationMsg]="'TikTok ID must be at most 24 characters long.'
                      "></app-input>
                  </div>
                </div>
                <div class="col-12">
                  <div>
                    <app-input [inputType]="'text'" [fieldValue]="user.faceBookId" [fieldText]="'facebook'"
                      [fControl]="formGroup.controls['Facebook']" [inputClass]="'form-control'"
                      [inputPlaceholder]="'Enter Facebook ID'" [inputLabel]="'Facebook'" [labelClass]="'form-label'"
                      [isRequired]="false" [customErrorValidationMsg]="'Invalid Facebook ID'"
                      (keydown.enter)="$event.preventDefault()" [minLengthValidationMsg]="'Facebook ID must be at least 5 characters long.'"
                      [maxLengthValidationMsg]="'Facebook ID must be at most 15 characters long.'
                      "></app-input>
                  </div>
                </div>
              </div>
              <div class="btn-grps mt-4">
                <app-button [btnText]="'SignUp'" [btnTitle]="'SignUp'" [btnCss]="'btn btn-primary w-100 btn-lg'"
                  (onBtnClick)="
                    onNextClick();
                    modal.close('Close click')
                  "></app-button>
                <app-button [btnText]="'Skip'" [btnTitle]="'Skip'" [btnCss]="'btn btn-text w-100 btn-md'" (onBtnClick)="
                   skipBtnClicked();
                    modal.close('Close click')
                  "></app-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<app-search-location (openProfileModal)="openModal(profileModal, 'add-profile-modal')"
  (FillAddressDetails)="FillAddressDetails($event)"
  [addressOnboarding]="formGroup.controls['Address'].value"
  [cityOnboarding]="formGroup.controls['City'].value"
  [businessDetaillat]="locations?.[0]?.latitude ?? 0"
  [businessDetaillng]="locations?.[0]?.longitude ?? 0"
  #searchLocationModal></app-search-location>
<app-registration-done #registrationDoneModal></app-registration-done>
